module.exports = __webpack_public_path__ + "static/media/how-rove-works.2dd9aa63.mp4";